import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import RoundedButton from 'Components/ComponentLibrary/Atoms/Inputs/RoundedButton';
import CenteredActions from 'Views/Page/Content/Modal/Components/CenteredActions';
import Header from 'Components/ComponentLibrary/Molecules/Header';
import BodyText from 'Components/ComponentLibrary/Atoms/Text/BodyText';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import useEventTrackingLogEvent, { categories, eventTypes } from 'EventTracking/useEventTrackingLogEvent';
import { useSnackbarContext } from 'Context/SnackbarContext';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';


const styles = (theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  field: {
    marginTop: theme.spacing(4),
  },
});

const Layout = ({
  className,
  classes,
}) => {
  const { clearModalCollection } = useModalContext();
  const { onSubmit, resource } = useMetaLayoutContext();
  const { displaySuccess } = useSnackbarContext();
  const { logStandardizedEvent } = useEventTrackingLogEvent();

  return (
    <Box
      className={classNames(classes.root, className)}
    >
      <Header
        title={resource.attr('title')}
      />
      <BodyText
        text={resource.attr('description')}
      />
      <MetaControlField className={classes.field} attr={'currentPassword'} type="password" />
      <MetaControlField className={classes.field} attr={'newPassword'} type="password" />
      <CenteredActions>
        <RoundedButton
          fullWidth
          onClick={async () => {
            logStandardizedEvent(categories.userSettingsSecurity, eventTypes.clickButton, 'Auth Factor Password: Submit New Password');
            const resp = await onSubmit();
            if (resp) {
              clearModalCollection();
              displaySuccess('Password updated');
            }
          }}
          test={'security-settings-button-password-modify-modal-continue-1'}
        >
          {'Continue'}
        </RoundedButton>
      </CenteredActions>
    </Box>
  );
};

Layout.defaultProps = {
  className: '',
};

Layout.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Layout);
